<ngx-change-password-form [loading]="loading$ | async" (output)="save($event)"></ngx-change-password-form>
